/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

const NavMenu = ({ children }: React.PropsWithChildren<{}>) => {
  return <div css={{ display: 'flex', alignItems: 'center', height: '100%' }}>{children}</div>;
};

export default NavMenu;
